import { useState, useEffect } from "react";
import { useStateValue } from "../context-store/AppStateProvider";
import fetch from "unfetch";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const useFetch = (endpointPath, params = {}) => {
  const [{ token }] = useStateValue();

  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const options = {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      'Authorization': 'Bearer ' + token
    },
    referrerPolicy: "no-referrer"
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      try {
        const queryParams = [];
        Object.keys(params).forEach(key => queryParams.push(`${key}=${params[key]}`));

        const res = await fetch(`${API_BASE_URL}/${endpointPath}?${queryParams.join('&')}`, {
          ...options as any
        });
        // json object will have success and error data
        const json = await res.json();

        if (!res.ok) {
          // error cases, response has error code and message
          setError(json);
        } else {
          setResponse(json);
        }
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, []);

  return { response, isLoading, error };
};

export default useFetch;
